import {
    SideBarSC,
    StageSC,
    StagesContainerSC,
    StagesSC,
    TitleSC,
} from "./styled";

export const SideBar = () => {
    return (
        <SideBarSC>
            <StagesContainerSC>
                <TitleSC>Stages</TitleSC>
                <StagesSC>
                    <StageSC />
                    <StageSC />
                    <StageSC />
                    <StageSC />
                </StagesSC>
            </StagesContainerSC>
        </SideBarSC>
    );
};
